<template>
    <NuxtLoadingIndicator v-bind="$props" color="var(--joy-color-primary-50)" :height="2" />
</template>

<script setup lang="ts">
    import {NuxtLoadingIndicator} from '#components';

    /*
     * Help from here to type correctly and avoid Vue error
     * https://stackoverflow.com/questions/77673024/extracting-props-from-vuetify-component-in-vue-3
     */
    type NuxtLoadingIndicatorProps = InstanceType<typeof NuxtLoadingIndicator>['$props'];
    interface INuxtLoadingIndicatorProps extends /* @vue-ignore */ NuxtLoadingIndicatorProps {}
    defineProps<INuxtLoadingIndicatorProps>();
</script>

<style scoped lang="scss">
    .nuxt-loading-indicator {
        position: relative !important;
        z-index: var(--joy-core-z-index-fixed-content) !important;
    }
</style>
